import { useCallback } from 'react';
import { getContainerFormatter } from './container-formatters/ContainerFormatterRegistry';
import CrmCardWrapper from './CrmCardWrapper';
import MaybeScrollingContainer from './container-formatters/MaybeScrollingContainer';
import MaybeLabeledContainer from './container-formatters/MaybeLabeledContainer';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const isCollapsibleLayout = layout => {
  return layout.collapsible;
};
function FormattedContainer({
  contentStyles,
  containerId,
  contents,
  CrmContainerContentRenderer,
  dataAttributes,
  focusedItem,
  isScrollable = false,
  layout,
  topSlot,
  tabIndex,
  observerManager,
  formatterRegistry,
  CardFormatter,
  usageTracker
}) {
  const commonProps = {
    contentStyles,
    containerId,
    contents,
    CrmContainerContentRenderer,
    focusedItem,
    isScrollable,
    topSlot,
    dataAttributes,
    observerManager,
    tabIndex,
    CardFormatter,
    usageTracker
  };

  // Get the formatter from the registry based on layout type
  const FormatterComponent = getContainerFormatter(layout, formatterRegistry);
  return /*#__PURE__*/_jsx(FormatterComponent, Object.assign({}, commonProps, {
    layout: layout
  }));
}
const CrmCardContainer = ({
  contentStyles,
  containerId,
  content,
  dataAttributes = {},
  focusedItem,
  formatterRegistry,
  i18nLoader,
  isScrollable,
  registry,
  topSlot,
  usageTracker,
  observerManager,
  tabIndex,
  CardFormatter
}) => {
  const CrmContainerContentRenderer = useCallback(({
    contentStyles: childContentStyles,
    content: childContent,
    topSlot: childTopSlot,
    tabIndex: childTabIndex
  }) => {
    return /*#__PURE__*/_jsx(CrmCardContainer, {
      contentStyles: childContentStyles,
      containerId: containerId,
      content: childContent,
      focusedItem: focusedItem,
      formatterRegistry: formatterRegistry,
      i18nLoader: i18nLoader,
      registry: registry,
      topSlot: childTopSlot,
      usageTracker: usageTracker,
      observerManager: observerManager,
      tabIndex: childTabIndex,
      CardFormatter: CardFormatter
    });
  }, [containerId, focusedItem, formatterRegistry, i18nLoader, observerManager, registry, usageTracker, CardFormatter]);
  if (content.type === 'CONTAINER') {
    const scrollInsideContainer = content.layout.type === 'TABS' && content.layout.use === 'scrollable';
    const shouldScroll = Boolean(isScrollable && !scrollInsideContainer);
    return /*#__PURE__*/_jsx(MaybeScrollingContainer, {
      shouldScroll: shouldScroll,
      children: /*#__PURE__*/_jsx(View, Object.assign({}, contentStyles, dataAttributes, {
        blockSize: scrollInsideContainer ? '100%' : undefined,
        children: /*#__PURE__*/_jsx(MaybeLabeledContainer, {
          isCollapsible: isCollapsibleLayout(content.layout),
          isLabeled: Boolean(content.layout.labeled),
          isEmpty: content.contents.length === 0,
          label: content.label,
          children: /*#__PURE__*/_jsx(FormattedContainer, {
            containerId: content.id,
            contents: content.contents,
            CrmContainerContentRenderer: CrmContainerContentRenderer,
            focusedItem: focusedItem,
            layout: content.layout,
            topSlot: topSlot,
            tabIndex: tabIndex,
            observerManager: observerManager,
            formatterRegistry: formatterRegistry,
            CardFormatter: CardFormatter,
            usageTracker: usageTracker
          })
        })
      }))
    });
  }
  return /*#__PURE__*/_jsx(CrmCardWrapper, {
    cardData: content,
    CardComponentOverride: content.CardComponent,
    registry: registry,
    usageTracker: usageTracker,
    tabIndex: tabIndex
  }, `${containerId}-${content.definition.cardId}-${tabIndex}`);
};
export default CrmCardContainer;